// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --font-family: 'Rubik', sans-serif;
    --main-color: #FFA300;
    --secondary-color: #FF5B00;
    --tertiary-color: #FFFFFF;
    --fourth-color: rgba(255, 255, 255, 0.6);
    --dark-primary-color: #14161B;
    --dark-secondary-color: #2A2B32;
    --dark-tertiary-color: #313131;
    --dark-fourth-color: #7C869E;
    --modal-background: var(--dark-primary-color);
    --mobile-modal-height: 72px;
  
    --sidebar-width: 17.85%;
    --tablet-sidebar-width: 64px;
    --mobile-header-height: 72px;
    --desktop-header-height: 72px;
    --max-width: 1980px;
  
    --dark-primary-new-color:#111319;
    --dark-secondary-new-color: #1E2028;
    --dark-tertiary-new-color: #323540;
    --dark-fourth-new-color: #94A5CD;
    --darkest-color: #090A0E;
    --dark-gradient: linear-gradient(180deg, #111319 0%, #1E2028 100%);

    --level-1: var(--secondary-color);
    --level-2: var(--dark-fourth-new-color);
    --level-3: var(--main-color);
  
    --attention-color: #A864FF;
    --warning-color: #FF5166;
    --approved-color: #03C697;
    --main-gradient: linear-gradient(180deg, #FFA300 0%, #FF5B00 100%);
    --premium-gradient: linear-gradient(180deg, #FFB000 0%, #FFF2D7 6.56%, #FFF 6.57%, #FFECBA 20.06%, #FEA800 52.97%, #F1C869 63.68%, #FFC100 76.44%, #F90 100%);
    --premium-solid-color: #FFD370;
    --premium-dark-color: #071931;
    --vh: 7px;
}

/* stylelint-disable-line */

html {
        background-color: var(--darkest-color);
    }

body {
        background-color: var(--darkest-color);
        min-height: 100vh; /* Fallback for browsers that do not support Custom Properties */
        min-height: calc(var(--vh) * 100);
    }

html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }

article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
        display: block;
    }

ol, ul {
        list-style: none;
    }

a:focus, a:active, a:hover {
        outline: 0;
    }

a {
        text-decoration: none;
    }

body, #root {
        height: 100%;
        margin: 0;
        -webkit-text-size-adjust: none;
           -moz-text-size-adjust: none;
                text-size-adjust: none;
    }

body *, #root * {
            box-sizing: border-box;
            font-family: var(--font-family);
        }

#root {
        width: 100%;
    }
`, "",{"version":3,"sources":["webpack://./src/common.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;IACzB,wCAAwC;IACxC,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,4BAA4B;IAC5B,6CAA6C;IAC7C,2BAA2B;;IAE3B,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;IAC7B,mBAAmB;;IAEnB,gCAAgC;IAChC,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,wBAAwB;IACxB,kEAAkE;;IAElE,iCAAiC;IACjC,uCAAuC;IACvC,4BAA4B;;IAE5B,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,kEAAkE;IAClE,6JAA6J;IAC7J,8BAA8B;IAC9B,6BAA6B;IAC7B,SAAS;AACb;;AAEmB,2BAA2B;;AAC1C;QACI,sCAAsC;IAC1C;;AAEA;QACI,sCAAsC;QACtC,iBAAiB,EAAE,gEAAgE;QACnF,iCAAiC;IACrC;;AAEA;QAaI,SAAS;QACT,UAAU;QACV,SAAS;QACT,eAAe;QACf,aAAa;QACb,wBAAwB;IAC5B;;AAEA;QAEI,cAAc;IAClB;;AAEA;QACI,gBAAgB;IACpB;;AAEA;QAGI,UAAU;IACd;;AAEA;QACI,qBAAqB;IACzB;;AAEA;QAEI,YAAY;QACZ,SAAS;QACT,8BAAsB;WAAtB,2BAAsB;gBAAtB,sBAAsB;IAM1B;;AAJI;YACI,sBAAsB;YACtB,+BAA+B;QACnC;;AAGJ;QACI,WAAW;IACf","sourcesContent":[":root {\n    --font-family: 'Rubik', sans-serif;\n    --main-color: #FFA300;\n    --secondary-color: #FF5B00;\n    --tertiary-color: #FFFFFF;\n    --fourth-color: rgba(255, 255, 255, 0.6);\n    --dark-primary-color: #14161B;\n    --dark-secondary-color: #2A2B32;\n    --dark-tertiary-color: #313131;\n    --dark-fourth-color: #7C869E;\n    --modal-background: var(--dark-primary-color);\n    --mobile-modal-height: 72px;\n  \n    --sidebar-width: 17.85%;\n    --tablet-sidebar-width: 64px;\n    --mobile-header-height: 72px;\n    --desktop-header-height: 72px;\n    --max-width: 1980px;\n  \n    --dark-primary-new-color:#111319;\n    --dark-secondary-new-color: #1E2028;\n    --dark-tertiary-new-color: #323540;\n    --dark-fourth-new-color: #94A5CD;\n    --darkest-color: #090A0E;\n    --dark-gradient: linear-gradient(180deg, #111319 0%, #1E2028 100%);\n\n    --level-1: var(--secondary-color);\n    --level-2: var(--dark-fourth-new-color);\n    --level-3: var(--main-color);\n  \n    --attention-color: #A864FF;\n    --warning-color: #FF5166;\n    --approved-color: #03C697;\n    --main-gradient: linear-gradient(180deg, #FFA300 0%, #FF5B00 100%);\n    --premium-gradient: linear-gradient(180deg, #FFB000 0%, #FFF2D7 6.56%, #FFF 6.57%, #FFECBA 20.06%, #FEA800 52.97%, #F1C869 63.68%, #FFC100 76.44%, #F90 100%);\n    --premium-solid-color: #FFD370;\n    --premium-dark-color: #071931;\n    --vh: 7px;\n}\n\n:global {          /* stylelint-disable-line */\n    html {\n        background-color: var(--darkest-color);\n    }\n\n    body {\n        background-color: var(--darkest-color);\n        min-height: 100vh; /* Fallback for browsers that do not support Custom Properties */\n        min-height: calc(var(--vh) * 100);\n    }\n\n    html, body, div, span, applet, object, iframe,\n    h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n    a, abbr, acronym, address, big, cite, code,\n    del, dfn, em, img, ins, kbd, q, s, samp,\n    small, strike, strong, sub, sup, tt, var,\n    b, u, i, center,\n    dl, dt, dd, ol, ul, li,\n    fieldset, form, label, legend,\n    table, caption, tbody, tfoot, thead, tr, th, td,\n    article, aside, canvas, details, embed, \n    figure, figcaption, footer, header, hgroup, \n    menu, nav, output, ruby, section, summary,\n    time, mark, audio, video {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font: inherit;\n        vertical-align: baseline;\n    }\n\n    article, aside, details, figcaption, figure, \n    footer, header, hgroup, menu, nav, section {\n        display: block;\n    }\n\n    ol, ul {\n        list-style: none;\n    }\n\n    a:focus,\n    a:active,\n    a:hover {\n        outline: 0;\n    }\n\n    a {\n        text-decoration: none;\n    }\n\n    body,\n    #root {\n        height: 100%;\n        margin: 0;\n        text-size-adjust: none;\n\n        * {\n            box-sizing: border-box;\n            font-family: var(--font-family);\n        }\n    }\n\n    #root {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
